import { Icon } from '@adobe/react-spectrum';

const RoadmapIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16 3.375C15.4175 3.375 14.884 3.57202 14.4481 3.89453C13.1084 3.06885 11.6934 2.53271 10.3057 2.38183C8.97999 2.2373 7.73817 2.4541 6.6272 2.95654C6.17847 2.59839 5.61743 2.375 5 2.375C3.55273 2.375 2.375 3.55273 2.375 5C2.375 5.65479 2.62451 6.24683 3.02246 6.70703C1.94397 9.17309 2.23218 12.052 3.82483 14.5325C3.54102 14.9517 3.375 15.4568 3.375 16C3.375 17.4473 4.55273 18.625 6 18.625C7.44727 18.625 8.625 17.4473 8.625 16C8.625 14.5527 7.44727 13.375 6 13.375C5.64062 13.375 5.29822 13.4482 4.98596 13.5796C3.77124 11.6245 3.52392 9.43628 4.29297 7.51587C4.51929 7.57983 4.75342 7.625 5 7.625C6.44727 7.625 7.625 6.44727 7.625 5C7.625 4.72046 7.56934 4.45605 7.48804 4.20312C8.29163 3.89062 9.17993 3.76855 10.1426 3.87207C11.2712 3.99585 12.4309 4.43115 13.5444 5.09912C13.4404 5.38135 13.375 5.68213 13.375 6C13.375 7.44727 14.5527 8.625 16 8.625C17.4473 8.625 18.625 7.44727 18.625 6C18.625 4.55273 17.4473 3.375 16 3.375ZM7.37501 16C7.37501 16.7578 6.75782 17.375 6.00001 17.375C5.2422 17.375 4.62501 16.7578 4.62501 16C4.62501 15.2422 5.2422 14.625 6.00001 14.625C6.75782 14.625 7.37501 15.2422 7.37501 16ZM5.00001 6.375C4.2422 6.375 3.62501 5.75781 3.62501 5C3.62501 4.24219 4.2422 3.625 5.00001 3.625C5.75782 3.625 6.37501 4.24219 6.37501 5C6.37501 5.75781 5.75782 6.375 5.00001 6.375ZM16 7.375C15.2422 7.375 14.625 6.75781 14.625 6C14.625 5.24219 15.2422 4.625 16 4.625C16.7578 4.625 17.375 5.24219 17.375 6C17.375 6.75781 16.7578 7.375 16 7.375Z"
          fill="#222222"
        />
      </svg>
    </Icon>
  );
};

export default RoadmapIcon;
